import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuContainer } from './MenuContainer';
import { Button } from '../common';
import { LobbiesList } from '../lobby/LobbiesList';
import { RaceShell } from '../elements/RaceShell';
import { DegenCollections } from './DegenCollections';
import { CreateLobby } from '../lobby/CreateLobby';
import { MenuHeader } from './MenuHeader';
import { logOut, selectNftSelected } from '../../store/userStore';
import { completeSignOut } from '../../auth';
import { network } from '../../constants/network';
import useScript from '../hooks/useScript';
import { contractMapping } from '../../constants/contract';
import { DegenRacerCollection } from '../garage/DegenRacerCollection';
import { DegenCollection, collectionConstMapping } from '../../constants/collections';
import { collectionMapping } from '../../constants/collectionMapping';
import { DegenDisassemble } from '../garage/DegenDisassemble';

export interface IMainMenuProps {
  // TODO(andrei): Move all these to the store
  accountAddress: string;
  accountAddressShort: string;
  nftsOwnedMiamiDegens: any[];
  nftsOwnedNYCDegens: any[];
  nftsOwnedSDGUStacksPunks: any[];
  nftsOwnedBitcoin: any[];
}

type DegenCollectionMapping = Record<DegenCollection, { collectionName: string; nftsOwned: any[]; baseSource: string }>;

export type MenuPage = 'MainMenu' | 'JoinLobby' | 'RaceClassic' | 'SelectDegen' | 'CreateLobby' | 'GrandPrix'; //| 'Garage';
export type HeaderActions = 'setSelectDegen' | 'logOut';

const ListItem: React.FC = (props) => {
  return <div className="my-2">{props.children}</div>;
};

export const MainMenu = (props: IMainMenuProps) => {
  const dispatch = useDispatch();
  const {
    accountAddress,
    accountAddressShort,
    nftsOwnedNYCDegens,
    nftsOwnedMiamiDegens,
    nftsOwnedSDGUStacksPunks,
    nftsOwnedBitcoin,
  } = props;

  const nftSelected = useSelector(selectNftSelected);
  console.log(nftSelected);

  const [raceLobbyProps, setRaceLobbyProps] = useState<any>(null);
  const updateRaceLobbyProps = (lobbyProps: any): void => {
    setRaceLobbyProps(lobbyProps);
  };
  const [menuPage, setMenuPage] = useState<MenuPage>('MainMenu');
  const onClickMainMenu = useCallback(() => setMenuPage('MainMenu'), []);
  const onClickJoinLobby = () => setMenuPage('JoinLobby');
  const onClickCreateLobby = () => setMenuPage('CreateLobby');
  const onClickSelectDegen = useCallback(() => setMenuPage('SelectDegen'), []);
  const onClickRaceClassic = () => (nftSelected ? setMenuPage('RaceClassic') : '');
  // const [isGrandPrix,setIsGrandPrix]=useState<boolean>
  const onClickGrandPrix = () => (nftSelected?.collectionName === 'BitcoinDegen' ? setMenuPage('GrandPrix') : '');
  // const onClickGarage = useCallback(() => setMenuPage('Garage'), []);

  const openLink = (link: string) => {
    window.open(link, '_blank');
  };

  // implementation to delete: does not take into account data-config ( search elements inspect element )
  // is a way to make it work?
  useEffect(() => {
    const divTag = document.createElement('div');
    divTag.id = 'root';
    document.body.appendChild(divTag);
    return () => {
      document.body.removeChild(divTag);
    };
  }, []);

  useScript(contractMapping[network].urlLNSwap, 'LNSwap-Widget-Script', [
    ['data-config', `{ 'name': 'lnswap', 'config': { 'targetElementId': 'root' } }`],
  ]);

  const onClickLogOut = useCallback(() => completeSignOut(dispatch), []);

  const headerActions = {
    setSelectDegen: onClickSelectDegen,
    logOut: onClickLogOut,
  };

  const isLobbyDisabled = network === 'testnet' ? false : !nftSelected;

  const mainMenuContent = (
    <MenuContainer
      content={
        <div className="main-menu-list">
          <ListItem>
            <div className="tooltipV2">
              <span className="tooltiptextV2">Exclusive Grand Prix only for Bitcoin Degens!</span>
              <Button
                label={'Bitcoin Degen Grand Prix'}
                onClick={onClickGrandPrix}
                disabled={!(nftSelected?.collectionName === 'BitcoinDegen')}
              />
            </div>
          </ListItem>
          <ListItem>
            <Button
              label={'Grand Prix Leaderboard'}
              onClick={() => {
                window.open('https://stacksdegens.com/leaderboard');
              }}
              disabled={!nftSelected}
            />
          </ListItem>
          <ListItem>
            <Button label={'Race classic'} onClick={onClickRaceClassic} disabled={!nftSelected} />
          </ListItem>

          <ListItem>
            <Button label={'Create lobby'} onClick={onClickCreateLobby} disabled={isLobbyDisabled} />
          </ListItem>

          <ListItem>
            <Button label={'Join lobby'} onClick={onClickJoinLobby} disabled={isLobbyDisabled} />
          </ListItem>

          {/* <ListItem>
            <Button label={'Leaderboard Classic'} />
          </ListItem> */}
          {/* <ListItem>
            <Button label={'Garage'} onClick={onClickGarage} />
          </ListItem> */}
          <ListItem>
            <Button label={'Select Degen'} onClick={onClickSelectDegen} />
          </ListItem>

          <ListItem>
            <Button
              label={'Mint Bitcoin Degen'}
              onClick={() => openLink('https://stacksdegens.com/mint-bitcoin-degens/')}
            />
          </ListItem>
        </div>
      }
    />
  );

  const collection = collectionMapping['NYC'](nftsOwnedNYCDegens, collectionConstMapping);

  const menuPageMapping: Record<MenuPage, JSX.Element> = {
    MainMenu: mainMenuContent,
    RaceClassic: <RaceShell onClickReloadMenu={onClickMainMenu} raceLobbyProps={raceLobbyProps} />,
    GrandPrix: <RaceShell onClickReloadMenu={onClickMainMenu} raceLobbyProps={raceLobbyProps} isGrandPrix={true} />,
    CreateLobby: (
      <CreateLobby
        onClickBack={onClickMainMenu}
        accountAddress={accountAddress}
        accountAddressShort={accountAddressShort}
      />
    ),
    JoinLobby: (
      <LobbiesList
        onClickBack={onClickMainMenu}
        updateRaceLobbyProps={updateRaceLobbyProps}
        onClickRace={onClickRaceClassic}
      />
    ),
    // Garage: (
    //   <DegenDisassemble
    //     nftsOwned={collection.nftsOwned}
    //     baseSource={collection.baseSource}
    //     collectionName={collection.collectionName}
    //     onClickMainMenu={onClickMainMenu}
    //     onClickBack={onClickMainMenu}
    //   />
    // ),
    SelectDegen: (
      <DegenCollections
        onClickBack={onClickMainMenu}
        nftsOwnedMiamiDegens={nftsOwnedMiamiDegens}
        nftsOwnedNYCDegens={nftsOwnedNYCDegens}
        nftsOwnedSDGUStacksPunks={nftsOwnedSDGUStacksPunks}
        nftsOwnedBitcoin={nftsOwnedBitcoin}
      />
    ),
  };

  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <div className="col-12 col-md-1" />
        <div className="col-12 col-md-10">
          <div className="text-center main-color main-menu-container">
            <MenuHeader headerActions={headerActions} />
            {menuPageMapping[menuPage]}
          </div>
        </div>
        <div className="col-12 col-md-1" />
      </div>
    </div>
  );
};
